<template>
  <BasicLayout>
    <template #wrapper>
      <common-export :get-table="getTables" :export-method="exportSuperSign" :import-method="importSuperSign" />
      <div style="margin-left: 50px;margin-top: 50px;">
        <el-button type="primary" @click="dialogVisible = true">添加</el-button>
      </div>
      <div slot="header" class="clearfix">
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="500px;"
        >
          <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0 0 20px;">
            <el-form-item label="选择类型">
              <el-select v-model="levelFormData.type" disabled style="width: 150px" placeholder="请选择">
                <el-option
                  v-for="item in conditionType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数值">
              <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addLevel">保存</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisibleScoreEvent"
          width="500px"
        >
          <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
            <el-form-item label="选择分组">
              <el-select v-model="scoreFormData.group" filterable style="width: 150px" multiple placeholder="请选择">
                <el-option
                  v-for="item in groups"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
            <el-button type="primary" @click="addGroup()">保存</el-button>
          </span>
        </el-dialog>

      </div>

      <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
        <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)">
          <template #label>
            <div>
              {{ getLabelName(tabItem.label) }}
              <i v-if="!checkFormData(tabItem.label)" class="el-icon-circle-close" style="margin-left:5px;font-size: 14px" @click="delCond(tabItem.label)" />
            </div>
          </template>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-form :inline="true">
              <el-form-item label="选择类型">
                <el-select v-model="tabItem.type" disabled filterable style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                  <el-option
                    v-for="item in conditionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="数值范围">
                <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
              </el-form-item>
            </el-form>
            <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
            <el-form>
              <div v-if="formData.hasOwnProperty(tabItem.label)">
                <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                  <el-card class="box-card" style="margin-top: 10px">
                    <div slot="header" class="clearfix" style="height: 60px;">
                      <el-form :inline="true">
                        <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                          <el-option
                            v-for="item in groups"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form>
                    </div>
                    <el-form>
                      <el-table :data="scoreItem.data[0].rewards.rewardList" border stripe>
                        <el-table-column prop="stage" label="阶段" width="50px">
                          <template v-slot:default="scope">
                            <span>{{ scope.row.stage }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="mType" label="类型">
                          <template v-slot:default="scope">
                            <el-select v-model.number="scope.row.mType" placeholder="请选择" @change="(v)=>buyChange(v, tabItem.label,scoreItem.group_name,scope.$index)">
                              <el-option
                                v-for="(item, index) in buyType"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column label="价格">
                          <template v-slot:default="scope">
                            <el-select v-if="scope.row.mType === 1" v-model.number="scope.row.price" placeholder="请选择" @change="(v)=>priceChange(v, tabItem.label,scoreItem.group_name,scope.$index)">
                              <el-option
                                v-for="(item, index) in shopSku"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="sku" label="SKU" width="250px">
                          <template v-slot:default="scope">
                            <el-input v-if="scope.row.mType ===1" v-model.number="scope.row.sku" readonly placeholder="库存" />
                            <el-input v-else v-model.number="scope.row.diamond" placeholder="钻石" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="scope" label="奖励">
                          <template v-slot:default="scope">
                            <Reward :value="scope.row.prize" />
                          </template>
                        </el-table-column>
                        <el-table-column label="操作">
                          <template v-slot:default="scope">
                            <el-button type="danger" @click="delEvent1(tabItem.label,scoreItem.group_name ,scope.$index)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button type="primary" style="margin-top: 10px" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>

                      <!-- 大奖-->
                      <el-card style="margin-top: 20px">
                        <div slot="header" class="clearfix">
                          <span>大奖</span>
                        </div>
                        <el-form-item label="大奖">
                          <Reward :value="scoreItem.data[0].rewards.lastReward" />
                        </el-form-item>
                      </el-card>

                      <!-- 大奖 end-->
                      <el-button style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                      <el-button v-if="scoreItem.data[0].id > 0" style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name, scoreItem.data[0].id)">删除</el-button>
                    </el-form>
                  </el-card>
                </el-row>
              </div>
            </el-form>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import {
  delActivityRewardCfg, getActivityAllList,
  getActivityTypeToMap, getConditionTypesList, importActivityRewardCfg
} from '@/api/config/activity-cfg'
import { getSku } from '@/api/config/shop-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getRewardListForType } from '@/utils'
import Reward from '@/components/Reward/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { exportSuperSign, getSuperSignInCfgList, importSuperSign, updateSuperSignInCfg } from '@/api/config/sign-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
export default {
  name: 'RewardSerialCollectPack',
  components: { CommonExport, Reward },
  data() {
    return {
      typ: '',
      isOnline: 0,
      ucType: 0,
      loading: false,
      aid: 0,
      blindBox: [],
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      shopSku: [],
      visibleArr: {},
      buyType: [
        { 'value': 1, 'label': '付费' },
        { 'value': 2, 'label': '绿钻' }
      ],
      coinType: [
        { label: 'money1', value: 'money1' },
        { label: 'money2', value: 'money2' },
        { label: 'money3', value: 'money3' },
        { label: 'money4', value: 'money4' },
        { label: 'money5', value: 'money5' },
        { label: 'money6', value: 'money6' }
      ],
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      conditionType: [],
      actType: '',
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level'
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      avatar: [],
      commonKey: 'SUPER_SIGNIN'
    }
  },
  created() {
    this.getSkuList()
    this.getConditionTypeData()
    this.typeChange('')
    this.getTables()
    this.getGroup()
  },
  methods: {
    importSuperSign,
    exportSuperSign,
    buyChange(v, levelName, scoreName, index) {
      if (v === 1) {
        this.formData[levelName][scoreName].data[0].rewards.rewardList[index].sku = this.shopSku[0].sku
        this.formData[levelName][scoreName].data[0].rewards.rewardList[index].price = this.shopSku[0].value
      } else {
        this.formData[levelName][scoreName].data[0].rewards.rewardList[index].sku = ''
        this.formData[levelName][scoreName].data[0].rewards.rewardList[index].price = 0
      }
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, levelName, scoreName, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      if (sku === '') {
        this.msgError('库存有误！')
        return
      }
      this.formData[levelName][scoreName].data[0].rewards.rewardList[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivityRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [, minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          console.log('activeName', this.activeName)
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          // const _formdata = scoreItem.data[0].rewards
          // const rewardList = _formdata.rewardList
          // if (condSub && scoreItem.data[0].rewards.length < 1) {
          if (scoreItem.data[0].rewards.length < 1) {
            this.msgError('空数据不能提交')
            return
            // continue
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormDataCondition[key] = condition
          console.log('条件 ', postFormDataCondition)
          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data[0]
          }
          const _data = scoreItem.data[0]
          const _dataLen = scoreItem.data[0].rewards.rewardList.length
          if (_dataLen % 7 !== 0) {
            this.msgError('数据长度必须是7的倍数')
            return
          }
          // _data.condition = key
          _data.aid = this.aid
          const stage = {}
          stage[key] = condition
          _data.stage = key
          _postData.push(_data)
        }
      }

      const cond = JSON.stringify(postFormDataCondition)
      updateCommonCfg({ name: this.commonKey, data: cond })
      // const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      _postData = JSON.stringify(_postData)
      console.log(cond)
      console.log(_postData)
      updateSuperSignInCfg({ data: _postData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.tabPane = []
      this.formData = []
      let cond = []
      getCommonCfg({ name: this.commonKey }).then(res => {
        cond = res.data
      })
      getSuperSignInCfgList().then(res => {
        const data = res.data
        // console.log(data)
        // const tab = {}
        for (const i in cond) {
          const val = cond[i]
          const levelName = 'level-' + val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: [{ rewards: { rewardList: [], lastReward: [] }}]
          })

          for (const ii in data) {
            const _event = data[ii]
            console.log('data', _event)
            if (_event.stage === i) {
              const rewards = { rewards: { rewardList: [], lastReward: [] }}
              rewards.rewards.rewardList = _event.reward
              rewards.rewards.lastReward = _event.last_reward
              // console.log('_event', rewards)
              this.$set(this.formData[levelName][scoreName], 'data', [rewards])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              type: 'level',
              bak_type: 'level',
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          this.tabPane.forEach((item, index) => {
            if (index === 0) {
              this.levelActiveName = item.label
            }
          })
        }
      })
    },
    levelChangeType(newVal, levelName) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      const oldLevelName = oldTabPane.label
      const newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === newLabelName) {
          this.msgError('当前类型配置已经存在')
          return
        }
      }
      oldTabPane.label = newLabelName
      this.tabPane[fileIndex] = oldTabPane
      this.levelActiveName = newLabelName
      if (Object.prototype.hasOwnProperty.call(this.formData, oldLevelName)) {
        const oldData = this.formData[oldLevelName]
        Vue.delete(this.formData, oldLevelName)
        this.$set(this.formData, newLabelName, oldData)
      }
    },
    levelChange(newVal, isMin, type, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = type + '-' + bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      this.$set(this.formData, newLevelName, oldData)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    delEvent1(levelName, scoreName, index, typ = 1) {
      const k = 'rewardList'
      this.formData[levelName][scoreName].data[0].rewards[k] = this.formData[levelName][scoreName].data[0].rewards[k].filter((item, key) => {
        return index !== key
      })

      let count = 0
      this.formData[levelName][scoreName].data[0].rewards[k].forEach((res, index) => {
        count++
        this.formData[levelName][scoreName].data[0].rewards[k][index].stage = count
      })
    },
    addEvent(levelName, scoreName, typ = 1) {
      const len = this.formData[levelName][scoreName].data[0].rewards.rewardList.length
      this.formData[levelName][scoreName].data[0].rewards.rewardList.push({
        stage: len + 1,
        mType: 1,
        price: 0,
        prize: [],
        sku: '',
        diamond: 0
      })
    },
    delEvent(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActivityRewardCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.$delete(this.formData[levelName], scoreName)
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              // this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })
      }
      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({ aid: 0, stage: [], rewards: { rewardList: [], lastReward: [] }})
      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      console.log(' this.formData', this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        // this.msgError('等级已经存在')
        // return
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      this.tabPane.push({
        'label': levelName,
        'type': this.levelFormData.type,
        'bak_type': this.levelFormData.type,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(ucType) {
      getRewardType({ data: ucType }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables()
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
    },
    getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards.rewardList[index].sku = ''
    }, getRewardList(prize) {
      return getRewardListForType(prize, this.rewardType)
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    }, delCond(label) {
      this.$confirm('此操作将永久删除该条件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabPane = this.tabPane.filter(item => {
          return item.label !== label
        })

        this.onSubmit(false)
      })
    },
    propChange(v, levelName, groupName, index, i) {
      const record = this.formData[levelName][groupName].data[0].rewards[index].prize[i]
      const typ = parseInt(v)
      record.num = 1
      switch (typ) {
        case 64:
          record.skin = this.chessId[0].value
          break

        case 19:
          record.skin = this.areaId[0].value
          break
        default:
          record.skin = 0
      }
      this.formData[levelName][groupName].data[0].rewards[index].prize[i] = record
      this.typeChange(v)
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    typeChange(v) {
      // if (this.activtyToTypeId.includes(v)) {
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivityAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
        }
      })
    },
    getActivityToType() {
      getActivityTypeToMap().then(res => {
        if (res.code === 200) {
          this.activtyToType = res.data
          for (const i in res.data) {
            this.activtyToTypeId.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
